module.exports = {"id":"223734","name":"Rolando García Guerreño","rating":"71","photo":"./data/images/photos/2/223734.png","club":{"name":"Lanús","logo":"./data/images/clubs/Lanus.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RolandoGarciaGuerreno0.json
// module id = 3680
// module chunks = 0